import { create } from 'zustand'

type State = {
  isActive: boolean
}

type Action = {
  toggleTerms: (param: boolean) => void
}

export const useTermsOfUse = create<State & Action>((set) => ({
  isActive: false,
  toggleTerms: (param: boolean) => set((state: any) => ({ isActive: param })),
}))
